<template>
  <div class="vx-col w-full mb-base" ref="popupContainer">
    <vx-card>
      <div class="vx-row w-full mb-2">
        <div class="vx-col w-1/2">
        <h1>Vérification des achats récurrents</h1>
        </div>
        <div class="vx-col w-1/2">
          <vs-button
            class="float-right"
            radius
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            @click="returnPrevRoute"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row w-full">
        <div class="vx-col mb-2">
          <vs-select
                v-model="accountManagerFilter"
                class="w-full select-medium mr-2"
                placeholder="Consultant"
                autocomplete
              >
              <vs-select-item
                value=""
                text="Tous les consultants"
                class="w-full"
              />
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.firstname + ' ' + item.lastname"
                v-for="(item, index) in account_managers"
                class="w-full"
              />
          </vs-select>
        </div>
        <div class="vx-col mb-2">
          <vs-input class="inputx" placeholder="Client" v-model="societyFilter" />
        </div>
        <div class="vx-col mb-2">
          <vs-input class="inputx" placeholder="Service" v-model="expertiseFilter" />
        </div>
        <div class="vx-col w-auto mb-2">
          <vs-button color="primary" class="float-right" @click="savePurchases()">Enregistrer tous les achats</vs-button>
        </div>

      </div>
      <div ref="purchaseTable" style="max-height:69vh; overflow: auto;">
        <CheckRecurringPurchasesTable ref="CheckRecurringPurchasesTable" :purchases="displayedPurchases"  @delete-line="removeLine($event)" @modify-purchase="modifyPurchase()" @renew-purchase="renewPurchase($event)"/>
      </div>
    </vx-card>
  </div>
</template>

<script>
import CheckRecurringPurchasesTable from "@/components/tables/CheckRecurringPurchasesTable";
import store from "@/store/store";

export default {
	name: "CheckRecurringPurchases",
	components: {
		CheckRecurringPurchasesTable
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			accountManagerFilter: "",
			societyFilter: "",
			activeFilter: false,
			expertiseFilter: "",
			accountManagerFilterOn: false,
			societyFilterOn: false,
			activeFilterOn: false,
			expertiseFilterOn: false,
			account_managers: [],
			displayedPurchasesFull: [],
			displayedPurchases: [],
			contract_users: [],
		};
	},
	created() {
		this.getAllPurchases();
		this.getAllSocieties();
		this.getAllServices();
	},
	beforeRouteLeave: function(to, from, next) {
		if(this.$refs.CheckRecurringPurchasesTable.beforeRouteLeave()){
			next();
		}
		else{
			next(false);
		}
	},
	mounted() {
		this.displayedPurchases = this.displayPurchases(this.purchases);
		this.displayedPurchasesFull = this.displayPurchases(this.purchases);
		this.getAllAccountManagers();
		this.getAllContractsUsersForPurchases(this.displayedPurchasesFull);
	},
	watch: {
		purchases: function(){
			//console.log("purchases WATCH");
			this.displayedPurchases = this.displayPurchases(this.purchases);
			this.displayedPurchasesFull = this.displayPurchases(this.purchases);
		},
		accountManagerFilter: function() {
			if(this.accountManagerFilter == "") {
				this.accountManagerFilterOn = false;
			}
			else{
				this.accountManagerFilterOn = true;
			}
			////console.log("nameFilter")
			this.displayedPurchases = this.filterPurchases(this.displayedPurchasesFull); //A CHANGER
		},
		societyFilter: function() {
			if(this.societyFilter == "") {
				this.societyFilterOn = false;
			}
			else{
				this.societyFilterOn = true;
			}
			////console.log("societyFilter")
			this.displayedPurchases = this.filterPurchases(this.displayedPurchasesFull); //A CHANGER
		},
		activeFilter: function() {
			this.activeFilterOn = true;
			////console.log("activeFilter")
			this.displayedPurchases = this.filterPurchases(this.displayedPurchasesFull); //A CHANGER
		},
		expertiseFilter: function() {
			if(this.expertiseFilter == "") {
				this.expertiseFilterOn = false;
			}
			else{
				this.expertiseFilterOn = true;
			}
			// //console.log("expertiseFilter", this.expertiseFilter)
			this.displayedPurchases = this.filterPurchases(this.displayedPurchasesFull); //A CHANGER
		},
	},
	computed: {
		purchases: () => {
			return store.state.purchases;
		},
		societies: () => {
			return store.state.societies;
		},
		services: () => {
			return store.state.services;
		}
	},
	methods: {
		/**
		 * Fetch all the purchases
		 */
		getAllPurchases() {
			////console.log("getAllPurchases BEGIN")
			this.$store.dispatch("getAllPurchasesWithRecurring");
			////console.log("getAllPurchases END")
		},

		/**
		 * Query our API to fetch all the account managers
		 */
		getAllAccountManagers() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then(res => {
					this.account_managers = res.data;
				})
				.catch(err => {
					console.error(err);
				});
		},

		getAllContractsUsersForPurchases(displayedPurcharsesFull) {
			let contract_ids = [];
			for(let purchase of displayedPurcharsesFull){
				if(!contract_ids.includes(purchase.contract_id)) contract_ids.push(purchase.contract_id);
			}
			let string_contract_ids = JSON.stringify(contract_ids);
			this.$http
				.get(this.apiUrl + "contract/getcus", {
					params: {
						contractids: string_contract_ids
					}
				})
				.then(res => {
					this.contract_users = res.data;
				})
				.catch(err => {
					console.error(err);
				});
		},

		removeLine(purchase){
			let purchaseToDelete = this.displayedPurchasesFull.find(element => element.id == purchase.id);
			//console.log(purchaseToDelete);
			this.displayedPurchasesFull = this.displayedPurchasesFull.filter(function(element){
				return element.id != purchase.id;
			});
			this.displayedPurchases = this.displayedPurchasesFull;
			//console.log("removeLine");
		},

		modifyPurchase(){
			this.$store.dispatch("getAllPurchasesWithRecurring");
			this.returnPrevRoute();
		},

		renewPurchase(purchaseId){
			this.$router.push({name: "new_entity", params: {purchaseId: purchaseId, newEntityForm: "renewpurchase"}});
		},

		getAccountManagerListForContract(contract_id){
			let filteredCU = this.contract_users.filter(cu => cu.contracts_id == contract_id);
			let accountmanagerList = [];
			//console.log("filteredCU", filteredCU);
			for(let row of filteredCU){
				accountmanagerList.push(row.users_id);
			}
			//console.log("accountmanagerList", accountmanagerList);
			return accountmanagerList;
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.accountManagerFilterOn || this.societyFilterOn || this.activeFilterOn || this.expertiseFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered purchases A CHANGER
		 * @param {String} nameFilterOn - Society is active?
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} expertiseFilterOn - Id of the commercial in charge of the project
		 * @return {List} - Societies' list filtered
		 */
		filterPurchases(purchases){
			////console.log("filterProviders BEGIN")
			let purchasesList = [];

			let searchKeyList = {};
			this.societyFilterOn ? searchKeyList["societyFilter"] = this.societyFilter.toLowerCase() : false;
			this.accountManagerFilterOn ? searchKeyList["accountManagerFilter"] = this.accountManagerFilter : false;
			this.expertiseFilterOn ? searchKeyList["expertiseFilter"] = this.expertiseFilter.toLowerCase() : false;

			for(let purchaseToFilter of purchases){
				////console.log(purchaseToFilter)
				let society_name = this.getSocietyIdToName(purchaseToFilter.contract_society_id);
				let service_name = this.getServiceIdToName(purchaseToFilter.service_id);
				// //console.log("service_name", service_name)
				if(society_name != "") society_name = society_name.toLowerCase();
				if(service_name != "") service_name = service_name.toLowerCase();

				let purchaseSearchKeyList = {};
				this.societyFilterOn ? purchaseSearchKeyList["societyFilter"] = society_name : false;
				this.accountManagerFilterOn ? purchaseSearchKeyList["accountManagerFilter"] = this.getAccountManagerListForContract(purchaseToFilter.contract_id) : false;
				this.expertiseFilterOn ? purchaseSearchKeyList["expertiseFilter"] = service_name : false;
				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof purchaseSearchKeyList[key] == "string"){
							if(!purchaseSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof purchaseSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of purchaseSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(Array.isArray(purchaseSearchKeyList[key])){
							//console.log("isArray");
							//console.log(purchaseSearchKeyList[key]);
							//console.log(searchKeyList[key]);
							if(!purchaseSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else{
							if(purchaseSearchKeyList[key] != searchKeyList[key]){
								check = false;
								break;
							}
						}
					}
				}

				if(check) purchasesList.push(purchaseToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return purchasesList;
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displayPurchases(purchases){
			////console.log("displayPurchases BEGIN")
			let purchasesList = [];
			if(this.displayedPurchases.length > 0){
				purchasesList = this.displayedPurchases;
			}
			else{
				if(!this.isFilterSet()){
					purchasesList = purchases;
				}
			}

			// getServiceIdToName
			if(purchasesList.length > 0){
				////console.log(purchasesList)
				purchasesList = purchasesList.filter(purchase => {
					if(purchase.recurrence_is_check !== null && purchase.recurrence_is_check !== undefined){
						if(purchase.recurrence_is_check == 0){
							return true;
						}
						else{
							return false;
						}
					}
					else{
						return false;
					}
				});
				for(let purchase of purchasesList){
					/*
					 * //console.log("purchase")
					 * //console.log(purchase)
					 * //console.log("purchase.service_id_list")
					 * //console.log(purchase.service_id_list)
					 */
					let service_name_list = [];
					/*
					 * //console.log("purchase.service_name_list")
					 * //console.log(purchase.service_name_list)
					 */
					if(purchase.service_name_list != undefined && purchase.service_name_list.length > 0){
						////console.log("purchase.service_name_list DEFINED")
						service_name_list = purchase.service_name_list;
					}
					else{
						////console.log("purchase.service_name_list UNDEFINED")
						if(purchase.service_id_list != undefined && purchase.service_id_list.length > 0){
							for(let service of purchase.service_id_list){
								service_name_list.push(this.getServiceIdToName(service));
							}
						}
					}
					purchase.service_name_list = service_name_list;
				}
			}
			/*
			 * return result
			 * //console.log("displayPurchases END")
			 */
			return purchasesList;
		},

		savePurchases(){
			this.$refs.CheckRecurringPurchasesTable.savePurchase();
		},

		returnPrevRoute(){
			this.$router.go(-1);
		},

		getSocietyIdToName(society_id){
			let society_name = "";
			let society = this.societies.find(society => society.id == society_id);
			if(society != undefined && society.name != undefined){
				society_name = society.name;
			}
			return society_name;
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties(){
			this.$store.dispatch("getAllSocieties");
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined && service.name != undefined){
				service_name = service.name;
			}
			return service_name;
		},
		getAllServices(){
			this.$store.dispatch("getAllServices");
		},
	}
};
</script>
